'use client';

import { cn } from '@/lib/cn';
import type { ButtonHTMLAttributes } from 'react';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variante?: 'primario' | 'contorno' | 'fantasma' | 'perigo';
  tamanho?: 'sm' | 'md';
};

const VARIANTES = {
  primario: 'bg-gray-900 text-white hover:bg-gray-800 disabled:bg-gray-400',
  contorno: 'border border-gray-200 bg-white text-gray-700 hover:bg-gray-50',
  fantasma: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
  perigo: 'border border-red-200 bg-white text-red-600 hover:bg-red-50'
};

export function Botao({ variante = 'primario', tamanho = 'md', className, ...props }: Props) {
  return (
    <button
      {...props}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors',
        'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500',
        'disabled:cursor-not-allowed disabled:opacity-60',
        tamanho === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm',
        VARIANTES[variante],
        className
      )}
    />
  );
}
